'use client'

import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from 'date-fns'

import { useEffect, useState } from 'react'
import { parseApiDateTime } from '@/helpers/parse-api-datetime'

export function TimeRemaining({
  deadlineAt,
  children,
}: Readonly<{
  deadlineAt: string
  children?: React.ReactNode
}>) {
  // `deadlineAt` vem em UTC sem timezone; `new Date()` leria como horário local.
  const target_date = parseApiDateTime(deadlineAt) ?? new Date()
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  })

  useEffect(() => {
    function updateCountdown() {
      const current_date = new Date()
      const days = differenceInDays(target_date, current_date)
      const hours = differenceInHours(target_date, current_date) % 24
      const minutes = differenceInMinutes(target_date, current_date) % 60

      setTime({ days, hours, minutes })

      if (days <= 0 && hours <= 0 && minutes <= 0) {
        clearInterval(interval)
      }
    }

    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [target_date])

  function formatValue(value: number) {
    if (value < 10) {
      return `0${value < 0 ? '0' : value}`
    }

    return value
  }

  return (
    <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-4 rounded-lg border border-[#9A3CFF] bg-[#F2E8FC] px-7 py-6 md:mt-12 md:flex-nowrap md:px-18.75 md:py-6">
      <h3 className="font-medium text-[#41196B] text-lg leading-6">
        Poucos dias para aproveitar nosso conteúdo{' '}
      </h3>
      <div className="flex w-full items-center gap-2 text-center md:max-w-76">
        <div className="w-full rounded-lg bg-[#8C37E8] py-3">
          <div className="text-center font-bold text-[#F8F9FA] text-base leading-5">
            <span className="block">{formatValue(time.days)}</span>
            <span>Dias</span>
          </div>
        </div>
        <div className="w-full rounded-lg bg-[#8C37E8] py-3">
          <div className="text-center font-bold text-[#F8F9FA] text-base leading-5">
            <span className="block">{formatValue(time.hours)}</span>
            <span>Horas</span>
          </div>
        </div>
        <div className="w-full rounded-lg bg-[#8C37E8] py-3">
          <div className="text-center font-bold text-[#F8F9FA] text-base leading-5">
            <span className="block">{formatValue(time.minutes)}</span>
            <span>Minutos</span>
          </div>
        </div>
      </div>
      {children}
    </div>
  )
}
